// src/context/user-context.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

import { GetUserDetails } from "../services/user-service";
import { userListName } from "../constants/global-values";
import { common } from "../messages/common-items";
import { getTokenAndListInfo } from "./item-helper";
import { Spinner, SpinnerSize } from "@fluentui/react";

type UserContextType = {
  role: string | null;      // null = not loaded yet
  loading: boolean;
};

const UserContext = createContext<UserContextType>({ role: null, loading: true });
const { Labels: Lbl_Common, SuccessMessages: Success_Common} = common;
export const useUser = () => useContext(UserContext);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { accounts, instance } = useMsal();
  const [role, setRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      const email = accounts[0]?.username;
      if (!email) return setLoading(false);

      try {
        const res = await getUserRole(email, instance);
        // Map your labels to English role keys
        const roleMap: Record<string, string> = {
          [Lbl_Common.SYSTEM]: "admin",
          [Lbl_Common.ONSITE]: "user",
          [Lbl_Common.HEADQUARTERS]: "headquaters",
        };

        const mappedRole = roleMap[res?.Role ?? ""] ?? "guest";
        setRole(mappedRole);
      } catch (err) {
        console.error("Error fetching user role", err);
        setRole(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, [accounts, instance]);

  // Don't render routes until role is loaded

  if (loading)
    return <div className="loadercommon-container">
      <Spinner label={Success_Common.LOADER_MSG} size={SpinnerSize.large} />
    </div>;

  return (
    <UserContext.Provider value={{ role, loading }}>
      {children}
    </UserContext.Provider>
  );
};

// Fetch role helper
export async function getUserRole(email: string, instance: any) {
  const { token, siteId, listId } = await getTokenAndListInfo(instance, userListName);
  const Role = await GetUserDetails(token, siteId, listId, email); // make sure this returns a Promise
  return Role;
}
